<template>
  <div class="navbar navbar-expand-lg navbar-light">
    <!-- <div class="text-center d-lg-none w-100">
      <button type="button" class="navbar-toggler dropdown-toggle" data-toggle="collapse" data-target="#navbar-footer">
        <i class="icon-unfold mr-2"></i>
        Footer
      </button>
    </div>

    <div class="navbar-collapse collapse" id="navbar-footer">
      <span class="navbar-text">
        &copy; 2022. Go Saas
      </span>
    </div> -->
    <ModalConvertOrder
      v-if="isModalConvertOrder"
      ref="modalConvertOrder"
    />
    <ModalOrderConfirm
      v-if="isModalOrderConfirm"
      ref="modalOrderConfirm"
    />
    <ModalSendOrderErp
      v-if="isModalSendOrderErp"
      ref="modalSendOrderErp"
    />
    <ModalSendOrderCrm
      v-if="isModalSendOrderCrm"
      ref="modalSendOrderCrm"
    />
    <ModalSendCustomer
      v-if="isModalSendCustomer"
      ref="modalSendCustomer"
    />
    <ModalSendProduct
      v-if="isModalSendProduct"
      ref="modalSendProduct"
    />

    <ModalGenTrackingCode v-if="isModalGenTrackingCode" />
    <ModalSendToFulfillment v-if="isModalSendToFulfillment" />
    <ModalPrintTiktok 
      v-if="isModalModalPrintTiktok"
      :list-data-print="listDataPrint"
    />
    <ModalUpdateProductLink v-if="isModalModalUpdateProductLink" />
    <ModalProgressSplitShipment 
      v-if="isModalSplitShipment" 
      :list-data-split-shipment="listDataSplitShipment"
    />
    <ModalProgressUnSplitShipment 
      v-if="isModalUnSplitShipment"
    />
    <ProgressBarPopUpComponent
      v-if="isOpenModal"
      :list-item-product-link="listDataProgressBar"
    />
    <ProgressBarPopUpUnlinkComponent
      v-if="isOpenModalUnlink"
      :list-item-product-unlink="listDataProgressBarUnlink"
    />
    <progress-bar-activity v-if="isProgressBarActivity" />
    <progress-bar-product v-if="isProgressBarProduct" />
    <progress-bar-inventory v-if="isProgressBarInventory" />
    <progress-bar-update-shipment v-if="isProgressBarUpdateShipment" />
    <modal-move-to-ready-to-ship v-if="isModalMoveToReadyToShip" />
    <ModalDownloadReportShippingChargeBilling v-if="isProgressReportShippingChargeBilling" />
    <ModalDownloadEntryData v-if="isProgressEntry" />

    <ModalUpdateSalable 
      v-if="isModalUpdateSalable"
      :product-update-salable="productUpdateSalable"
    />
  </div>
</template>

<script>
import ModalConvertOrder from '@/components/tenancy/admin/ordersdrafts/ModalConvertOrder'
import ModalOrderConfirm from '@/components/tenancy/admin/orders/ModalOrderConfirm'
import ModalSendOrderErp from '@/components/tenancy/admin/orders/ModalSendOrderErp'
import ModalSendOrderCrm from '@/components/tenancy/admin/orders/ModalSendOrderCrm'
import ModalGenTrackingCode from '@/components/tenancy/admin/shipment/ModalGenTrackingCode'
import ModalSendToFulfillment from '@/components/tenancy/admin/shipment/ModalSendToFulfillment'
import ModalPrintTiktok from '@/components/tenancy/admin/shipment/ModalPrintTiktok'
import ProgressBarProduct from '@/components/tenancy/admin/products/ProgressBarProduct'
import ProgressBarInventory from '@/components/tenancy/admin/inventory/inventoryList/ProgressBarInventory'
import ProgressBarUpdateShipment from '@/components/tenancy/admin/shipment/ProgressBarUpdateShipment'
import ModalUpdateProductLink from '@/components/tenancy/admin/productlink/ModalUpdateProductLink'
import ProgressBarActivity from '@/components/tenancy/admin/crm/activities/ProgressBarActivity'
import ModalMoveToReadyToShip from '@/components/tenancy/admin/shipment/ModalMoveToReadyToShip'
import ModalDownloadEntryData from '@/components/tenancy/admin/tool/customize/forms/assets/ModalDownloadEntryData'
import ModalDownloadReportShippingChargeBilling from '@/components/tenancy/admin/report/finance/ModalDownloadReportShippingChargeBilling'
import ModalSendCustomer from '@/components/tenancy/admin/customer/ModalSendCustomer.vue'
import ModalSendProduct from '@/components/tenancy/admin/products/ModalSendProduct.vue'
import Cookies from "js-cookie"
import ProgressBarPopUpComponent from '@/components/tenancy/center/ProgressBarPopUpComponent.vue';
import ModalProgressSplitShipment from '@/components/tenancy/admin/shipment/ModalProgressSplitShipment';
import ModalProgressUnSplitShipment from '@/components/tenancy/admin/shipment/ModalProgressUnSplitShipment';
import ModalUpdateSalable from '@/components/tenancy/admin/stock/ModalUpdateSalable.vue'
import ProgressBarPopUpUnlinkComponent from '@/components/tenancy/center/ProgressBarPopUpUnlinkComponent.vue';

export default {
  name: 'FooterContent',
  components: {
    ModalConvertOrder,
    ModalOrderConfirm,
    ModalSendOrderErp,
    ModalSendOrderCrm,
    ModalGenTrackingCode,
    ModalPrintTiktok,
    ProgressBarProduct,
    ProgressBarInventory,
    ProgressBarUpdateShipment,
    ModalUpdateProductLink,
    ModalMoveToReadyToShip,
    ModalDownloadEntryData,
    ModalDownloadReportShippingChargeBilling,
    ProgressBarActivity,
    ModalSendCustomer,
    ModalSendProduct,
    ProgressBarPopUpComponent,
    ModalSendToFulfillment,
    ModalProgressSplitShipment,
    ModalProgressUnSplitShipment,
    ModalUpdateSalable,
    ProgressBarPopUpUnlinkComponent
  },
  computed: {
    isModalConvertOrder() {
      return this.$store.state.order.isModalConvertOrder;
    },
    isModalOrderConfirm() {
      return this.$store.state.order.isModalOrderConfirm;
    },
    isModalSendOrderErp() {
      return this.$store.state.order.isModalSendOrderErp;
    },
    isModalSendOrderCrm() {
      return this.$store.state.order.isModalSendOrderCrm;
    },
    isModalGenTrackingCode() {
      return this.$store.state.shipment.isModalGenTrackingCode;
    },
    isModalSendToFulfillment() {
      return this.$store.state.shipment.isModalSendToFulfillment;
    },
    isModalModalPrintTiktok() {
      return this.$store.state.shipment.isModalModalPrintTiktok;
    },
    isProgressBarProduct() {
      return this.$store.state.product.isProgressBarProduct.open;
    },
    isProgressBarUpdateShipment() {
      return this.$store.state.shipment.isProgressBarUpdateShipment;
    },
    isModalModalUpdateProductLink() {
      return this.$store.state.product.isModalModalUpdateProductLink;
    },
    isProgressBarActivity() {
      return this.$store.state.customer.isProgressBarActivity;
    },
    isModalMoveToReadyToShip() {
      return this.$store.state.shipment.isModalMoveToReadyToShip.isShowProgress;
    },
    isProgressEntry() {
      return this.$store.state.forms.isProgressEntry;
    },
    isProgressReportShippingChargeBilling() {
      return this.$store.state.reports.isProgressReportShippingChargeBilling;
    },
    isModalSendCustomer() {
      return this.$store.state.customer.isModalSendCustomer;
    },
    isModalSendProduct() {
      return this.$store.state.product.isModalSendProduct;
    },
    listDataProgressBar() {
      return this.$store.state.product.listDataProgressBar;
    },
    isOpenModal() {
      return this.$store.state.product.isOpenModal;
    },
    isProgressBarInventory() {
      return this.$store.state.inventory.isProgressBarInventory;
    },
    isModalSplitShipment() {
      return this.$store.state.shipment.isModalSplitShipment;
    },
    listDataSplitShipment() {
      return this.$store.state.shipment.listDataSplitShipment;
    },
    isModalUnSplitShipment() {
      return this.$store.state.shipment.isModalUnSplitShipment;
    },
    unSplitShipmentId() {
      return this.$store.state.shipment.unSplitShipmentId;
    },
    listDataPrint() {
      return this.$store.state.shipment.listDataPrint;
    },
    isOpenModalUnlink() {
      return this.$store.state.product.isOpenModalUnlink;
    },
    listDataProgressBarUnlink() {
      return this.$store.state.product.listDataProgressBarUnlink;
    },
    isModalUpdateSalable() {
      return this.$store.state.product.isModalUpdateSalable;
    },
    productUpdateSalable() {
      return this.$store.state.product.productUpdateSalable;
    },
  },
  async created() {
    let reportsCookie = await this.$store.dispatch("reports/getGenerateReportsLocalStorage");
    if (reportsCookie) {
      this.$store.dispatch("reports/isProgressReportShippingChargeBilling", true);
    }
    let entryCookie = await this.$store.dispatch("forms/getGenerateEntryLocalStorage");
    if (entryCookie) {
      this.$store.dispatch("forms/isProgressEntry", true);
    }
  },
}
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/layouts/tenancy/admin/FooterContent.vue